import { useCountry } from "@App/hooks/useCountry";
import { actionCreators, type State } from "@App/state";
import { setDateLocale } from "@App/utils/dates";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const DIAL_CODES = { DE: "+49", AT: "+43" } as const;

/**
 * Applies the two global side effects of the resolved country. Mounted once in
 * `RepareoFunnel`, next to the existing `i18n.changeLanguage` effect — everything
 * else reads the country through `useCountry()` without side effects.
 */
export const useSyncCountry = (): void => {
  const country = useCountry();
  const phone = useSelector((state: State) => state.orders.phone);

  const dispatch = useDispatch();
  const { setPhone } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    setDateLocale(country);
  }, [country]);

  useEffect(() => {
    // Only ever a preselection: once the customer has typed a number, a later place
    // change must not rewrite their input.
    if (phone?.number) return;

    const dialCode = DIAL_CODES[country];
    if (phone?.country === dialCode) return;

    setPhone({ country: dialCode, number: phone?.number ?? null });
  }, [country, phone?.number]);
};
